import { useEffect, useState } from 'react';
import { APIError, api } from '../../../lib/api';
import {
  cloneOneBitmapSharedConfig,
  getOneBitmapRuntimeSharedConfigEndpoint,
  parseOneBitmapSharedConfig,
  type OneBitmapSharedConfig,
} from '../../../lib/onebitmap/sharedConfig';

interface OneBitmapSharedConfigState {
  config: OneBitmapSharedConfig | null;
  loading: boolean;
  error: string | null;
  hasRemoteConfig: boolean;
}

export function useOneBitmapSharedConfig() {
  const [state, setState] = useState<OneBitmapSharedConfigState>({
    config: null,
    loading: true,
    error: null,
    hasRemoteConfig: false,
  });

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const response = await api(getOneBitmapRuntimeSharedConfigEndpoint(), {
          method: 'GET',
        });
        const parsed = parseOneBitmapSharedConfig(response?.data?.config);

        if (parsed.issues.length > 0) {
          console.warn('[OneBitmap] Configuração compartilhada inválida, usando fallback.', parsed.issues);
        }

        if (!mounted) {
          return;
        }

        setState({
          config: cloneOneBitmapSharedConfig(parsed.config),
          loading: false,
          error: parsed.issues.length > 0
            ? 'A configuração compartilhada veio incompleta e o OneBitmap voltou para um fallback seguro.'
            : null,
          hasRemoteConfig: true,
        });
      } catch (error) {
        if (!mounted) {
          return;
        }

        if (error instanceof APIError && error.status === 404) {
          setState({
            config: null,
            loading: false,
            error: null,
            hasRemoteConfig: false,
          });
          return;
        }

        setState({
          config: null,
          loading: false,
          error:
            error instanceof Error
              ? error.message
              : 'Não foi possível carregar a configuração compartilhada do OneBitmap.',
          hasRemoteConfig: false,
        });
      }
    };

    void load();

    return () => {
      mounted = false;
    };
  }, []);

  return state;
}
